
const assert = require('assert');
const relativePath = require('../index');

describe('relative-path', function() {

  it('will return a path with a ./ prepended', function() {

    const currentDir = '/foo/bar/beep';
    const relativeFile = '/foo/bar/beep/meow/foop.sh';

    assert.equal(relativePath(currentDir, relativeFile), './meow/foop.sh');
  });


  it('will return a path with a ../ prepended when path is located in a sibling directory', function() {

    const currentDir = '/foo/bar/beep';
    const relativeFile = '/foo/bar/boop/meow/foop.sh';

    assert.equal(relativePath(currentDir, relativeFile), '../boop/meow/foop.sh');
  });


  it('will return a path with a ../../ prepended if curernt dir is two levels up', function() {

    const currentDir = '/foo/bar/beep/zzz';
    const relativeFile = '/foo/bar/boop/meow/foop.sh';

    assert.equal(relativePath(currentDir, relativeFile), '../../boop/meow/foop.sh');
  });


});
